export type LogoTransform = { x: number; y: number; zoom: number };
export type LogoPoint = { x: number; y: number };
// Points and offsets are percentages of the square display window, centred at 0.
export function moveLogo(current: LogoTransform, from: LogoPoint, to: LogoPoint, ratio = 1): LogoTransform {
  const zoom = Math.max(.1, Math.min(12, current.zoom * ratio));
  const scale = zoom / current.zoom;
  return { zoom, x: to.x - (from.x - current.x) * scale, y: to.y - (from.y - current.y) * scale };
}
